import React, { useState } from "react";
import { Button, Icon, Confirm, Popup } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { Subject } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { SubjectForm } from "../SubjectForm";
import "./SubjectItem.scss";

const subjectController = new Subject();

export function SubjectItem(props) {
  const { subject, onReload } = props;
  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateSubject = () => {
    setTitleModal(`Actualizar asignatura: ${subject.name}`);
    onOpenCloseModal();
  };

  const openDeleteConfirm = () => {
    setConfirmMessage(`¿Eliminar la asignatura ${subject.name}?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await subjectController.deleteSubject(accessToken, subject.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="subject-item">
        <div className="subject-item__info">
          <span className="subject-item__info-name">{subject.name}</span>
        </div>
        <div>
          <Popup
            content="Actualizar asignatura"
            trigger={
              <Button icon primary onClick={openUpdateSubject}>
                <Icon name="pencil" />
              </Button>
            }
          />
          <Popup
            content="Eliminar asignatura"
            trigger={
              <Button icon color="red" onClick={openDeleteConfirm}>
                <Icon name="trash" />
              </Button>
            }
          />
        </div>
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <SubjectForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          subject={subject}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
